export default __webpack_public_path__ + "locales/nl/SingleSignOn.json?hash=aa34b5e4c043a8a80f0e17b4437265f4";